var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCrossWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L7.5 7.5",
    transform: "translate(-436 -1110) translate(437 1111.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L7.5 7.5",
    transform: "translate(-436 -1110) translate(437 1111.5) matrix(-1 0 0 1 7.5 0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCrossWhite);
export default __webpack_public_path__ + "static/media/ic_cross_white.97141a60a3f6227a4d2777d1dc33dcd7.svg";
export { ForwardRef as ReactComponent };